import request from '@/services/request'
import baseUrl from '@/services/baseUrl'

const path = `${baseUrl.main}/cs/v1/`

export default {
  getCharities: (params = {}) => request.post(path + 'charity/bo/list', params),
  getCraSyncStatus: () => request.post(path + 'charity/bo/cra/status', {}),
  refreshCraRegistry: () => request.post(path + 'charity/bo/cra/refresh', {}),
  getCharity: id => request.post(path + 'charity/bo/detail/' + id),
  approveCharity: id => request.post(path + 'charity/bo/approve/' + id),
  approveBankChange: (id, body) => request.post(path + 'charity/bo/bank/approve/' + id, body),
  rejectCharity: (id, rejectionReason) => request.post(path + 'charity/bo/reject/' + id, { rejectionReason }),
  deactivateCharity: id => request.post(path + 'charity/bo/deactivate/' + id),
  deleteCharity: id => request.post(path + 'charity/bo/delete/' + id),
  updateAdvisoryProfile: (id, params) => request.post(path + 'charity/bo/advisory/profile/' + id, params),
  createAdvisoryCampaign: params => request.post(path + 'charity/bo/advisory/campaign', params),
  listAdvisoryCampaigns: params => request.post(path + 'charity/bo/advisory/campaigns', params),
  getCountries: (params = {}) => request.post(path + 'fundraiser/bo/countries?', params),
  listCoupons: () => request.post(path + 'charity/bo/coupons/list', {}),
  createCoupon: params => request.post(path + 'charity/bo/coupons', params),
  deactivateCoupon: id => request.post(path + 'charity/bo/coupons/deactivate/' + id, {}),
}
